import { all, takeLatest, put, call } from 'redux-saga/effects';
import { onGetInsuredRisks } from './api';

import { getInsuredRisks, getInsuredRisksSucceeded, getInsuredRisksFailed } from './slice';

export function* getInsuredRisksWorker({ payload }) {
  try {
    const response = yield call(onGetInsuredRisks, payload);
    yield put(getInsuredRisksSucceeded(response.data));
  } catch {
    yield put(getInsuredRisksFailed());
  }
}

export default function* insuredRisksSaga() {
  yield all([takeLatest(getInsuredRisks.type, getInsuredRisksWorker)]);
}
